
// Used for sending messages to the Chrome extension for synchronizing auth state
export const DATAGRAB_SIGNIN = 'datagrab_signin'
export const DATAGRAB_SIGNOUT = 'datagrab_signout'
export const DATAGRAB_SYNC_USER_PROFILE = 'datagrab_sync_user_profile'